import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { TDistributorType } from "../types/distributorTypes.types";
import { getFullDateFormat } from "../../../utils/dateFormater";

type DistributorTypeTableProps = {
  data: TDistributorType[];
  isLoading: boolean;
} & Pick<
  DataTableProps<TDistributorType>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<TDistributorType>[] = [
  { key: "name", label: "Nombre" },
  { key: "createdBy", label: "Creado por" },
  { key: "createdAt", label: "Fecha de creación" },
  { key: "updatedBy", label: "Editado por" },
  { key: "updatedAt", label: "Última edición" },
  { key: "active", label: "Estado", isBoolean: true },
];

export const DistributorTypeTable = ({
  isLoading,
  ...rest
}: DistributorTypeTableProps) => {
  if (isLoading) return <Loading />;
  return (
    <DataTable
      columns={columns}
      tableId="distributor-types-table"
      customRender={(key, item) => {
        if (key === "createdAt" || key === "updatedAt") {
          if (!item[key]) return null;
          return getFullDateFormat(item[key] as Date);
        }
        if (key === "createdBy") {
          return item.userCreated
            ? `${item.userCreated.name} ${item.userCreated.lastName}`
            : "N/A";
        }
        if (key === "updatedBy") {
          return item.userUpdated
            ? `${item.userUpdated.name} ${item.userUpdated.lastName}`
            : "N/A";
        }
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
